/* Mizozu skin for the CSB chat launcher + window frame (its shadow root is open;
   the chat conversation itself is the CSB engine's iframe and is styled there). */
(() => {
  const CSS = `
    .l{background:#ffc300!important;color:#111!important;border:2px solid #111!important;
       box-shadow:0 4px 0 #111!important;font:400 16px/1 'Titan One','Arial Black',system-ui,sans-serif!important;letter-spacing:.02em!important}
    .l:hover{transform:translateY(-2px) rotate(-2deg)!important;box-shadow:0 6px 0 #111!important}
    .l:focus-visible{outline:3px solid #a9e55c!important}
    .b{background:#feae1f!important;color:#111!important;box-shadow:0 0 0 2px #111!important}
    .p{border:2.5px solid #111!important;border-radius:26px!important;background:#f4e7bf!important;
       box-shadow:0 8px 0 #111,0 24px 50px rgba(17,17,17,.25)!important}
  `;
  function skin() {
    const host = document.querySelector('csb-chat');
    const sr = host && host.shadowRoot;
    if (!sr || sr.querySelector('style[data-hw-skin]')) return !!sr;
    const st = document.createElement('style');
    st.setAttribute('data-hw-skin', '');
    st.textContent = CSS;
    sr.appendChild(st);
    return true;
  }
  let tries = 0;
  const t = setInterval(() => {
    if (skin() || ++tries > 40) clearInterval(t);
  }, 500);
})();
